__turbopack_context__.v({
  "carousel": "TeaserCarousel-module-scss-module__a04BYq__carousel",
  "controls": "TeaserCarousel-module-scss-module__a04BYq__controls",
  "row": "TeaserCarousel-module-scss-module__a04BYq__row",
  "rowItem": "TeaserCarousel-module-scss-module__a04BYq__rowItem",
  "viewport": "TeaserCarousel-module-scss-module__a04BYq__viewport",
});
